export const OFFER_IMAGE_ASPECT = 16 / 9;
export const OFFER_IMAGE_BACKGROUND = '#fff';
export const offerImageSx = { aspectRatio: '16 / 9', objectFit: 'contain', bgcolor: OFFER_IMAGE_BACKGROUND };

export const DEFAULT_OFFER_IMAGE = '/images/defaults/offer-default-v1.jpeg';

// Historical offers without a saved image keep their original public cover.
export const LEGACY_OFFER_IMAGE = 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?&auto=format&fit=crop&w=800&q=80';

export const hasOfferImage = (image) => typeof image === 'string' && image.trim().length > 0;

export const offerCoverImage = (image, isPreview = false) => (
  hasOfferImage(image) ? image : isPreview && image === '' ? '' : LEGACY_OFFER_IMAGE
);
